import CostReportInner from "./CostReportInner";

export default function CostReportPage() {
  return (
    <div className="space-y-3" data-testid="cost-report-page">
      <h1 className="text-2xl">Cost report</h1>
      <p className="text-sm opacity-70">
        Picks what to bill the client this week. Markup and pro-rata are optional
        and default OFF. Click <b>Mark these items as reported</b> once you've
        sent the PDF so next week starts fresh.
      </p>
      <CostReportInner/>
    </div>
  );
}
